import { Link, useNavigate } from 'react-router-dom';
import React from "react";

export function NavLink({children, to, ...rest}) {
  const navigate = useNavigate();

  const handleNavigation = React.useCallback(
    (to) => {
      history.pushState({}, "", to);
      navigate(to);
    },
    [navigate],
  );

  return (
    <Link
      to={to}
      {...rest}
      onClick={(e) => {
        e.preventDefault();
        handleNavigation(to);
      }}
    >
      {children}
    </Link>
  );
}